<div mdbModal #resultadoAsignacion="mdb-modal" class="modal fade" style="overflow-y: auto" id="basicExample"
  tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Resultado de la Seleccion
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
          (click)="resultadoAsignacion.hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row" style="border-bottom: 1px solid #dee2e6;">
          <div class="col">
            <h5 class="modal-title w-100 text-left" id="myModalLabel">
              Resultado
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col mt-1">
            <div class="table-responsive">
              <table class="table table-striped table-hover table-sm align-middle" *ngIf="listadoResultadoAsignados">
                <thead class="grey lighten-2">
                  <tr>
                    <th scope="col">Fecha</th>
                    <th scope="col">Doc</th>
                    <th scope="col">Caja</th>
                    <th scope="col">Unidad</th>
                    <th scope="col">Peso</th>
                    <th scope="col">Volumen</th>
                    <th scope="col">Monto</th>
                    <th scope="col">Comuna</th>
                    <th scope="col">Vendedor</th>
                    <th scope="col">Estado</th>
                    <th scope="col">Rut</th>
                    <th scope="col">Cliente</th>
                    <th scope="col">Direccion</th>
                    <th scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td colspan="100%" style="text-align: center" *ngIf="listadoResultadoAsignados?.length === 0">
                      No se encontró información
                    </td>
                  </tr>
                  <tr *ngFor="let mov of listadoResultadoAsignados">
                    <td class="text-center">{{ mov.fecha_emision | fecha}}</td>
                    <td class="text-center">{{ mov.folio }}</td>
                    <td class="text-center">{{ mov.caja }}</td>
                    <td class="text-center">{{ mov.unidad }}</td>
                    <td>{{ mov.total_peso }}</td>
                    <td>{{ mov.total_volumen | numerico }}</td>
                    <td>$ {{ mov.total_monto | numerico }}</td>
                    <td>{{ mov.comuna }}</td>
                    <td>{{ mov.vendedor }}</td>
                    <td>{{ mov.estado_cliente }}</td>
                    <td class="text-center">{{ mov.rutFormato | rut }}</td>
                    <td>{{ mov.nombre_cliente }}</td>
                    <td>{{ mov.direccion_completa }}</td>
                    <td></td>
                  </tr>
                </tbody>
                <tbody class="blue lighten-5">
                  <tr>
                    <td class="text-right"><strong>Cantidad: {{listadoResultadoAsignados.length | numerico}}</strong>
                    </td>
                    <td><strong></strong></td>
                    <td class="text-center"><strong>{{sumCajas | numerico}}</strong></td>
                    <td class="text-center"><strong>{{sumUnidad | numerico}}</strong></td>
                    <td><strong>{{sumPeso | numerico}}</strong></td>
                    <td><strong>{{sumVolumen | numerico}}</strong></td>
                    <td><strong>${{sumMonto | numerico}}</strong></td>
                    <td><strong></strong></td>
                    <td><strong></strong></td>
                    <td><strong></strong></td>
                    <td><strong></strong></td>
                    <td><strong></strong></td>
                    <td><strong></strong></td>
                    <td><strong></strong></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="modal-footer justify-content-between">
          <button type="button" class="btn btn-default waves-light" data-dismiss="modal"
            (click)="resultadoAsignacion.hide()" mdbWavesEffect>
            Cerrar
          </button>
          <app-api-button (click2)="asignar()" [processing]="processing"> Asignar </app-api-button>
        </div>
      </div>
    </div>
  </div>

  <app-modal-confirm></app-modal-confirm>